export const SITE_NAME = "En Edem Germania";

export const LOCATION = {
    venue: "Mineralix-Arena",
    street: "Ringstraße 67",
    town: "Weingarten (Baden)",
    city: "76356 Weingarten (Baden)", // PLZ + Ort
    center: [49.0500615, 8.519812],
};

// Routenplanung in Google Maps (Kontaktseite, Karte)
export const ROUTE_URL = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
    `${LOCATION.street}, ${LOCATION.city}, Deutschland`,
)}`;

export const CONTACT = {
    phone: "07244 9469991",
    phoneHref: "tel:+4972449469991",
    email: "info@en-edem.de",
};
